import EngineModule from '../../../EngineModule';
import { NS as StandingNS } from '../../../components/customers/standing/Standing/Standing';
export default () => new EngineModule.LogicalEngineModule({
	type :             'logical',
	id :               'standing',
	dependencies :     [
		'oms-basket',
		'viewer-planner',
		'viewer-planner-layout-editor',
		'viewer-planner-dimensionsEditor'
	],
	allowedCustomers : [ /* Local MPA */'XUJG0A2TF5', /* Prod */'STAODAZNIS' , 'sam1_12345'],
	insertionPath :    null,
	generateComponentConfiguration() : StandingNS.Configuration {
		return {

		};
	},
	async initialize() {
	}
});
